/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
const handlePhoneRegister = async (event) => {
	event.preventDefault();

	const errorElement = document.querySelector('.phone-register-error-banner.hidden');
	const errorClass = '.phone-register-error-banner';
	if (!errorElement) {
		hiddenError(errorClass);
	}

	const phoneNumber = document.getElementById('PhoneRegisterForm-Phone').value;

	try {
		toggleLoadingBtn('phone-register');
		const response = await fetch(`${PROXY}/otp/send`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ phoneNumber, uuid: sessionStorage.getItem('otp-uuid') }),
		});

		if (!response.ok) {
			throw new Error('somethingWrong');
		}
		const jsonResponse = await response.json();

		if (!jsonResponse.success) {
			throw new Error('somethingWrong');
		}

		openOtpLoginPopup(null, 'otp-code');
		document.querySelector('#phoneNumberId').textContent = jsonResponse.phone;
		closeOtpLoginPopup('phone-register');
	} catch (error) {
		showError(errorClass, 'somethingWrong');
	} finally {
		toggleLoadingBtn('verify-customer-id');
	}
};
